import { useConfig } from "@jti/app-context/useConfig";

export const useTransformImageUrl = () => {
  const config = useConfig();
  const deviceImages = config.deviceImages;

  const transformImageUrl = (productName: string, color?: string): string => {
    const variants = deviceImages?.[productName as keyof typeof deviceImages];
    if (!variants) {
      return "";
    }

    const searchColor = color?.toLowerCase();
    const variant = variants.find((variant) => variant?.color?.toLowerCase() === searchColor);

    return variant?.image || "";
  };

  return transformImageUrl;
};
